import React from 'react';

const PageTitle = () => {
    return (
        <div id="page-title">
            <div className="wrapper">
                <div className="title">
                    <h1 className="large">News</h1>
                </div>
            </div>
        </div>
    );
};

export default PageTitle;
